import { IonSpinner, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chatboxOutline, heartCircleOutline, heartOutline, chatbubbleEllipses, earth, heart, heartCircle } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { Component }  from 'react';

import UserBar from '../components/UserBar'; 
import LikeBar from '../components/LikeBar'; 
import ActionComp from '../components/ActionComp'; 
import { LANGUAGE, GetStr } from "../language/Language";
import { ReadyAds, ShowAds } from "../components/Admob";

import '../pages/Main.css'; 

  
const ImageContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate, view, autoplay }) => {
    
    const router = useIonRouter();

    // click on content
    const showContent = async () => {
        if (content.locked < 1 && view == "def")
        {
            let ready = await ReadyAds();
            if (!ready)
                router.push("/content/" + content.id + "/n", "forward", "push");
            else
            {
                ShowAds( () => {
                    router.push("/content/" + content.id + "/ad", "forward", "push");
                });
            }
        }
    }

    // click on the image
    const clickImage = (index : number) => {
        // only work in full mode
        if (view == "full")
        {
            let img = "";
            if (index < 0)
                img = content.thumbnail;
            else if (index < content.images.length)
                img = content.images[index];
            if (img == "")
                return;

            router.push("/imgviewer/" + encodeURIComponent(img) + "/" + (index+1) + "/" + content.id + "/content", 
                "forward", "push");
        }
    }

    return (
        <div className="image-content">
            <UserBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
            <div className="lock-wrapper" onClick={showContent}>    
                {
                    /* for content locked */
                    content.locked > 1 ?
                <div className="img-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heartCircle} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_SUPERLIKE_TO_UNLOCK) }
                </div>
                    :
                    content.locked == 1 ?
                <div className="img-lock">
                    {
                        content.opening ?
                    <IonSpinner name="lines-sharp" color="success" />
                        :
                    <IonIcon icon={heart} size="large" />
                    }<br/>
                    { GetStr(LANGUAGE.TXT_LIKE_TO_UNLOCK) }
                </div>
                    :
                <div/>
                }

                <IonImg className={ content.images == null || content.images.length < 1 ? "image-thumbnail" : "img-thumb-1" } 
                    style={{ height: content.heights[0] > 0 ? content.heights[0] : "100%" }}
                    src={content.thumbnail} onClick={()=> clickImage(-1)} />
                {
                    /* rest of the image */
                    content.images != null ?
                <div>
                {
                    view == "full" ?
                    <div>
                    {
                        content.images.map( (item, key) => {
                            return (
                                <IonThumbnail className={ content.images.length == 1 ? "img-thumb-1" : 
                                    (content.images.length == 2 ? "img-thumb-2" : "img-thumb-3") } 
                                    key={key} >
                                    <IonImg src={item} onClick={()=> clickImage(key)} 
                                        style={{ height: content.heights[key+1] > 0 ? content.heights[key+1] : "100%" }}
                                    />
                                </IonThumbnail>
                            )
                        })
                    }
                    </div>
                    :
                    <div>
                    {
                        content.images.slice(0, 3).map( (item, key) => {
                            return (
                                <IonThumbnail className={ content.images.length == 1 ? "img-thumb-1" : 
                                    (content.images.length == 2 ? "img-thumb-2" : 
                                    (content.images.length > 3 && key==2 ? "img-thumb-more" : "img-thumb-3")) } 
                                    key={key} >
                                    <IonImg src={item} onClick={()=> clickImage(key)} 
                                        style={{ height: content.heights[key+1] > 0 ? content.heights[key+1] : "100%" }} />
                                    {
                                        content.images.length > 3 && key==2 ?
                                    <div className="more-img">+{content.images.length-2}</div>
                                        :
                                    <div/>
                                    }
                                </IonThumbnail>
                            )
                        })
                    }
                    </div>
                }
                </div>
                    :
                <div/>
                }
            </div>
            {
                content.title != "" || content.desc != "" ?
            <IonItem lines="none" onClick={showContent}>
                <IonLabel className="ion-text-wrap">
            {
                content.title != "" ?
                <IonText className="content-title">{content.title}<br/></IonText>
                :
            <div/>
            }

            {
                content.desc != "" ?
                <IonText className="content-desc">{content.desc}</IonText>
                :
            <div/>
            }
                </IonLabel>
            </IonItem>
                :
            <div/>
            }
            <ActionComp content={content} />
            <LikeBar content={content} index={index} onUpdate={onUpdate} view={view} autoplay={autoplay} />
        </div>
    );
};
  
export default ImageContent;